import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ReputationScore {
  score: number;
  level: 'excellent' | 'good' | 'regular' | 'low';
  color: string;
  events_count: number;
}

export interface ReputationEvent {
  id: string;
  points_change: number;
  description: string;
  entity_type: string;
  entity_id: string | null;
  created_at: string;
}

@Injectable({ providedIn: 'root' })
export class ReputationService {
  private readonly API_URL = '/api/v1/reputation';

  constructor(private http: HttpClient) {}

  getScore(): Observable<ReputationScore> {
    return this.http.get<any>(`${this.API_URL}/score`).pipe(
      map(res => ({
        score: res.score,
        level: res.level,
        color: res.color,
        events_count: res.events_count,
      }))
    );
  }

  getHistory(limit = 20, offset = 0): Observable<ReputationEvent[]> {
    return this.http.get<any>(`${this.API_URL}/history`, {
      params: { limit: limit.toString(), offset: offset.toString() }
    }).pipe(
      map(res => res.events || [])
    );
  }
}
